<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <delete-user
      v-if="showDelete"
      :title="'Delete User?'"
      @closed="showDelete = false"
      @confirmed="deleteConfirmed()"
    />
    <edit-role
      v-if="showEdit"
      :role="existingRole"
      :userid="userId"
      @closed="showEdit = false"
    />
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account
      </v-icon> Users List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createUser()"
        >
          <v-icon dark>
            mdi-pencil
          </v-icon>
          Create New
        </v-btn>
      </v-col>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            lg="4"
          >
            <v-autocomplete
              v-model="selectedOrganizationName"
              menu-props="auto"
              :items="organizationList"
              item-value="external_id"
              item-text="name"
              label="Select Organization"
              outlined
              dense
              @input="getUsersListByOrganization()"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items=" usersList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.first_name }}</td>
            <td>{{ item.last_name }}</td>
            <td>
              <p v-if="item.organization === null">
                Super Admin
              </p>
              <p v-else>
                {{ item.organization.name }}
              </p>
            </td>
            <td>
              <p v-if="item.role === null">
                Not assigned
              </p>
              <p v-else>
                {{ item.role.name }}
              </p>
            </td>
            <td>
              <p v-if="item.address === null">
                N/A
              </p>
              <p v-else>
                {{ item.address.line1 }},{{ item.address.line2 }}<font v-if="item.address.line2 !== null">
                  ,
                </font>{{ item.address.city }},{{ item.address.state }},{{ item.address.country }}
              </p>
            </td>
            <td>{{ item.email }}</td>
            <td>{{ item.updated_at | diffHumans }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click="editUserRole(item.role,item.external_id)"
              >
                <v-icon> mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="red"
                @click="deleteUser(item.external_id)"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <v-btn
      v-if="!showUsersList"
      color="red darken-3"
      @click="back()"
    >
      Back
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';
  import Constants from 'src/constants';
  import EditRole from 'src/views/dashboard/users/EditRole.vue';

  export default {
    name: 'UsersList',
    components: {
      'centre-spinner': spinner,
      'delete-user': DeleteDialog,
      'edit-role': EditRole,
    },
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        showDelete: false,
        deleteUserId: '',
        selectedOrganizationName: '',
        headers: [
          { text: 'First Name', align: 'start', value: 'first_name' },
          { text: 'Last Name', value: 'last_name' },
          { text: 'Organization Name', value: 'name' },
          { text: 'Role', value: 'name' },
          { text: 'Address', value: 'address' },
          { text: 'Email', value: 'email' },
          { text: 'Last Updated', value: 'updated_at' },
          { text: 'Edit Role', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
        showEdit: false,
        existingRole: '',
        userId: '',
      };
    },
    computed: {
      usersList () {
        return this.$store.getters['users/getUsersList'];
      },
      organizationList () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
      showUsersList () {
        return this.selectedOrganizationName === '';
      },
    },
    async mounted () {
      this.$store.dispatch('organizations/fetchOrganizationList');
      await this.getUsersList();
    },
    methods: {
      async getUsersList () {
        this.loading = true;
        await this.$store.dispatch('users/fetchUsersList');
        this.loading = false;
      },
      deleteUser (deleteId) {
        this.showDelete = true;
        this.deleteUserId = deleteId;
      },
      async deleteConfirmed () {
        await this.$store.dispatch('users/deleteUser', this.deleteUserId)
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'User deleted successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            if (this.selectedOrganizationName === null || this.selectedOrganizationName === '') {
              this.getUsersList();
              return;
            }
            this.getUsersListByOrganization();
          }).finally(
            this.showDelete = false,
            this.deleteId = null,
            this.search = '',
          );
      },
      createUser () {
        this.$router.push({ name: 'Create User' });
      },
      async getUsersListByOrganization () {
        if (this.selectedOrganizationName === null || this.selectedOrganizationName === '') {
          return;
        }
        this.loading = true;
        await this.$store.dispatch('users/fetchUsersListByOrganization', this.selectedOrganizationName);
        this.loading = false;
      },
      back () {
        this.selectedOrganizationName = '';
        this.getUsersList();
      },
      editUserRole (userRole, userId) {
        this.existingRole = userRole.id;
        this.userId = userId;
        this.showEdit = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
</style>
